import { getSublistsOptions } from "../../../utils/FilterList";
import { CheckboxAtom, ListAtom, ListItemAtom, SpacerAtom } from "../../atoms";
import { ICategoryList } from "../../interfaces/CategoryList";
import { ICheckbox } from "../../interfaces/Checkbox";
import { LabelMolecule } from "../label";
import styles from "./styles.module.scss";

interface Props {
  list: ICategoryList[];
  onClick: (cb: ICheckbox) => void;
}

export function CheckboxListMolecule(props: Readonly<Props>) {
  const listItems = (items: ICheckbox[]) => {
    return items.map((option: ICheckbox) => {
      return (
        <ListItemAtom key={option.id} bold={option.bold}>
          <CheckboxAtom {...option} onClick={() => props.onClick(option)} />
        </ListItemAtom>
      );
    });
  };

  return (
    <>
      {props.list.map((categoryList: ICategoryList, index: number) => (
        <div key={"div_" + categoryList.title}>
          {getSublistsOptions(categoryList).map((cl: ICategoryList) => {
            return (
              <div key={"subList_" + cl.title} className={styles.sub}>
                <div className={styles.list}>
                  {cl.title && (
                    <>
                      <LabelMolecule id={cl.title} label={cl.title} />
                      <SpacerAtom space={2} />
                    </>
                  )}
                  <ListAtom unstyled>{listItems(cl.options)}</ListAtom>
                </div>
                <SpacerAtom space={2} />
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
}
